import { App } from './render/app';

const container = document.getElementById('app');
if (!container) throw new Error('#app missing');

/** A plain explanation instead of a blank page when the browser can't run the city. */
function fatal(title: string, detail: string): void {
  const d = document.createElement('div');
  d.className = 'fatal';
  const h = document.createElement('h2');
  h.textContent = title;
  const p = document.createElement('p');
  p.textContent = detail;
  d.append(h, p);
  container!.replaceChildren(d);
}

const gl2 = (() => {
  try {
    return !!document.createElement('canvas').getContext('webgl2');
  } catch {
    return false;
  }
})();

if (!gl2) {
  fatal('WebGL 2 is not available', 'PerpCity draws the city with WebGL 2. Try a current version of Chrome, Edge, Firefox or Safari, and check that hardware acceleration is turned on in the browser settings.');
} else {
  try {
    const app = new App(container);
    app.start();
    // Handy for debugging from the console.
    (window as unknown as { app: App }).app = app;
  } catch (e) {
    console.error(e);
    fatal('The city could not start', String(e instanceof Error ? e.message : e));
  }
}
